<template>
  <div class="container communityDetail communityProduct" v-if="commentinfo">
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      :is-disabled-data="disabled"
      @on-infinite="onInfinite"
    >
      <div class="commentProduct pro_comment_item flex-js" v-if="bannerList && bannerList.length">
        <div class="comment_head_info" @click="goHome">
          <div class="img">
            <head-pendant :identity="commentinfo.identity">
              <img
                v-if="commentinfo.authorhead"
                :src="commentinfo.authorhead"
                @error="
                  (event) => {
                    let img = event.srcElement
                    img.src = errorHeadImg
                    img.onerror = null
                  }
                "
              />
              <img v-if="!commentinfo.authorhead" :src="errorHeadImg" />
            </head-pendant>
          </div>
          <div class="info">
            <div class="name f16 flex-ac">
              <p class="over-ell-1">{{ commentinfo.authorname }}</p>
              <img
                v-if="commentinfo.authorlevel && commentinfo.authorlevel != 0"
                :src="$getVipLevel(commentinfo.authorlevel)"
              />
            </div>
          </div>
        </div>
        <div class="comment_head_btn f10" v-if="commentinfo && commentinfo.ismyself != 1">
          <button v-if="commentinfo && commentinfo.isfollow != 1" @click="followFn">关注</button>
          <button v-else class="gray" @click="followFn">取消关注</button>
        </div>
        <div class="comment_head_btn f10 report" @click="report">
          <img src="/static/images/community/report.png" />
        </div>
      </div>
      <div class="maininfo">
        <div ref="ifscroll" class="swiper-container" id="pro_pic" style="height: auto;">
          <div
            class="comment_head_btn f10 report"
            v-if="!(bannerList && bannerList.length)"
            @click="report"
          >
            <img src="/static/images/community/report_1.png" />
          </div>
          <div style="min-height: 6.67rem" v-if="!(bannerList && bannerList.length)">
            <div class="swiper-slide" style="background: #333;height: 100%;">
              <div
                style="width: 100%;height: 100%;"
                v-if="commentinfo.coverimg != null && commentinfo.coverimg != ''"
              >
                <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start -->
                <img
                  :src="
                    commentinfo.coverimg.indexOf(
                      $cos.isCosSwitch == 1 ? $cos.imageLinkParamsKey : '?x-oss-process'
                    ) >= 0
                      ? commentinfo.coverimg
                      : commentinfo.coverimg +
                        ($cos.isCosSwitch == 1
                          ? $cos.pathSymbol(commentinfo.coverimg) +
                            $cos.imageLinkParamsStr
                          : '?x-oss-process=image/format,jpg')
                  "
                  @load="loadvideo"
                  style="display:none;"
                />
                <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End -->
                <div class="zy_media" style="width: 100%;height: 100% !important;">
                  <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start -->
                  <video
                    id="banner_video"
                    style="width: 100%;height: 100%;"
                    :poster="
                      commentinfo.coverimg.indexOf(
                        $cos.isCosSwitch == 1 ? $cos.imageLinkParamsKey : '?x-oss-process'
                      ) >= 0
                        ? commentinfo.coverimg
                        : commentinfo.coverimg +
                          ($cos.isCosSwitch == 1
                            ? $cos.pathSymbol(commentinfo.coverimg) +
                              $cos.imageLinkParamsStr
                            : '?x-oss-process=image/format,jpg')
                    "
                    data-config="创客村"
                    webkit-playsinline="true"
                    playsinline="true"
                    x5-playsinline="true"
                    x-webkit-airplay="allow"
                    preload="true"
                  >
                    <source :src="commentinfo.videourl" type="video/mp4" />
                    <source :src="commentinfo.videourl" type="video/m3u8" />
                    您的浏览器不支持HTML5视频
                  </video>
                  <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End -->
                </div>
              </div>
            </div>
            <!--          <a class="downVideo" href="javascript:;" @click="downVideo(commentinfo.videourl)">下载</a>-->
            <!--          <div class="downVideo" @click="downVideo(, 'video')">下载</div>-->
          </div>
          <swiper
            v-if="bannerList && bannerList.length"
            style="height: 5rem"
            :options="swiperOption"
            ref="mySwiper"
          >
            <swiper-slide v-for="(item, index) of bannerList" :key="index">
              <img
                style="height: 100%;object-fit: contain;"
                v-lazy="item"
                @click="preview(index)"
              />
            </swiper-slide>
          </swiper>
          <div
            id="proSwiperPagination"
            class="swiper-pagination swiper-pagination-fraction"
            v-if="bannerList && bannerList.length > 0"
          >
            <div class="pro_page">
              <span class="swiper-pagination-current">{{ activeIndex + 1 }}</span>
              <span class="swiper-pagination-split">/</span>
              <span class="swiper-pagination-total">{{ bannerList.length }}</span>
            </div>
          </div>
          <div class="community_content" v-if="!(bannerList && bannerList.length)">
            <div class="commentProduct pro_comment_item community_userinfo flex">
              <div class="comment_head_info" @click="goHome">
                <div class="img">
                  <head-pendant :identity="commentinfo.identity">
                    <img
                      v-if="commentinfo.authorhead"
                      :src="commentinfo.authorhead"
                      @error="
                        (event) => {
                          let img = event.srcElement
                          img.src = errorHeadImg
                          img.onerror = null
                        }
                      "
                    />
                    <img v-if="!commentinfo.authorhead" :src="errorHeadImg" />
                  </head-pendant>
                </div>
                <div class="info">
                  <div class="name f16 flex-ac">
                    <p class="over-ell-1">{{ commentinfo.authorname }}</p>
                    <img
                      v-if="commentinfo.authorlevel && commentinfo.authorlevel != 0"
                      :src="$getVipLevel(commentinfo.authorlevel)"
                    />
                  </div>
                </div>
              </div>
              <div class="comment_head_btn f10" v-if="commentinfo && commentinfo.ismyself != 1">
                <button v-if="commentinfo && commentinfo.isfollow != 1" @click="followFn">
                  关注
                </button>
                <button v-else class="gray" @click="followFn">取消关注</button>
              </div>
            </div>
            <div class="maincontent">
              <div
                class="comment_txt f16 w-b"
                style="font-weight: bold;margin-bottom: 0.04rem;"
                v-if="commentinfo.title"
                v-html="commentinfo.title"
              ></div>
              <div
                class="comment_txt f14 w-b content"
                :class="{ 'over-ell-2': !isunfold, overflow: isunfold }"
                v-html="commentinfo.content"
              ></div>
              <div
                class="comment_txt f10"
                style="margin-top:0.03rem;"
                v-if="isunfold && commentinfo.releasetime"
              >
                {{ commentinfo.releasetime }}
              </div>
              <div class="flex-js-ac">
                <div v-if="commentinfo.subject" class="topic f14" @click="goSubjectid">
                  #{{ commentinfo.subject }}
                </div>
                <div class="topic f13" @click="isunfold = !isunfold">
                  {{ isunfold ? '收起' : '展开全文' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="commentinfo.star != 0"
        class="maincontent"
        style="padding: 0;margin-bottom: -0.15rem;"
      >
        <star :star="commentinfo.star" :pathClass="['detail']"></star>
      </div>
      <div class="maincontent">
        <div
          class="comment_txt f16 w-b"
          style="font-weight: bold;margin-bottom: 0.04rem;"
          v-if="commentinfo.title && bannerList && bannerList.length"
          v-html="commentinfo.title"
        ></div>
        <div
          class="comment_txt f14 w-b"
          v-if="bannerList && bannerList.length"
          v-html="commentinfo.content"
        ></div>
        <div
          v-if="commentinfo.subject && bannerList && bannerList.length"
          class="topic f14"
          @click="goSubjectid"
        >
          {{ commentinfo.subject }}
        </div>
        <div
          class="product"
          :class="{ marginTop: bannerList && bannerList.length }"
          v-if="commentinfo && commentinfo.productlist && commentinfo.productlist.length"
          :style="commentinfo.productlist.length >= 2 ? { 'padding-right': '0.52rem' } : {}"
        >
          <div class="scroll">
            <ul>
              <li
                class="flex-s"
                v-for="item of commentinfo.productlist"
                :class="{ itemWidth: commentinfo.productlist.length >= 2 }"
                @click="goProductDetail(item)"
              >
                <van-icon
                  class="close"
                  name="clear"
                  size="0.14rem"
                  @click.stop="closeFn(item)"
                  color="#C4C4C4"
                />
                <img class="flex-s" v-if="item.img_path" v-lazy="item.img_path" />
                <div class="name">
                  <p class="f12 over-ell-2">{{ item.name }}</p>
                  <p class="f12 price">
                    ¥{{ item.sales_price }}
                    <span class="f10">¥{{ item.cost_price }}</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div
            class="f0 moreProduct"
            v-if="commentinfo && commentinfo.productlist && commentinfo.productlist.length >= 2"
            @click.stop="productShow = true"
          >
            <van-icon name="arrow" size="0.15rem!important" color="#1D1E1E" />
            <p class="f10 color-9">{{ commentinfo.productlist.length }}个商品</p>
          </div>
        </div>
        <div
          class="f10 color-9"
          style="margin-top:0.1rem;"
          v-if="commentinfo.releasetime && bannerList && bannerList.length"
        >
          {{ commentinfo.releasetime }}
        </div>
      </div>
      <div
        class="comment_list flex-js-ac"
        style="padding-bottom: 0.15rem"
        v-if="
          commentinfo &&
            commentinfo.ismyself == 1 &&
            commentinfo.isreward == 1 &&
            commentinfo.identity == 3
        "
        @click="rewarddetails"
      >
        <div class="comment_tit">帖子收到打赏金额</div>
        <div class="f14 color-FC0324 flex-ac">
          {{ commentinfo.rewardvalue > 0 ? commentinfo.rewardvalue + '金币' : 0 }}
          <van-icon
            v-if="commentinfo.rewardvalue > 0"
            name="arrow"
            color="#FC0324"
            size="0.14rem"
          />
        </div>
      </div>
      <div class="comment_list" v-if="commentlist">
        <div class="comment_tit">
          <!--        <img src="../../assets/images/ly.png"/>-->
          评价({{ commentinfo.commentnum }})
        </div>
        <div class="list" v-if="commentlist && commentlist.length > 0">
          <div
            class="pro_comment_item"
            v-for="(item, index) of commentlist"
            :key="index"
            @click.stop="openSelect({ item: item, index: index })"
          >
            <div class="pro_comment_item_box">
              <div>
                <div class="comment_head_info">
                  <div class="img">
                    <head-pendant :identity="item.identity">
                      <img
                        v-if="item.comment_head"
                        :src="item.comment_head"
                        @error="
                          (event) => {
                            let img = event.srcElement
                            img.src = errorHeadImg
                            img.onerror = null
                          }
                        "
                      />
                      <img v-if="!item.comment_head" :src="errorHeadImg" />
                    </head-pendant>
                  </div>
                  <div class="info">
                    <div class="namebox">
                      <div class="name flex-ac">
                        <p class="over-ell-1">{{ item.comment_name }}</p>
                        <img
                          v-if="item.authorlevel && item.authorlevel != 0"
                          :src="$getVipLevel(item.authorlevel)"
                        />
                      </div>
                      <div class="time" v-if="item.isauthor">作者</div>
                    </div>
                    <div class="comment_content_info">
                      <div class="comment_txt" :class="{ delete: item.isdeleted == 1 }">
                        {{ item.isdeleted != 1 ? item.comment : '该内容已删除' }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="comment_content_info"
                  @click.stop="commentFn({ item: item, index: index })"
                >
                  <div class="comment_txt name time" style="padding-left: 0.3rem;">
                    {{ item.comment_time }}
                  </div>
                  <div class="comment_txt name time reply_btn">
                    回复
                  </div>
                </div>
              </div>
              <div
                class="love"
                v-if="item.isdeleted != 1"
                @click.stop="likeFn({ item: item, index: index })"
              >
                <img
                  :src="
                    item.ispraise == 0
                      ? '/static/images/community/notlike.png'
                      : '/static/images/community/like.png'
                  "
                />
                <p>{{ item.praisenum }}</p>
              </div>
            </div>
            <div
              class="pro_comment_item pro_comment_item_box comment_reply_item"
              v-if="item.isdeleted != 1"
              v-for="(itemSon, indexSon) of item.comment_reply"
              :key="indexSon"
              @click.stop="
                openSelect({ item: item, index: index, itemSon: itemSon, indexSon: indexSon })
              "
            >
              <div>
                <div class="comment_head_info">
                  <div class="img">
                    <head-pendant :identity="itemSon.identity">
                      <img
                        v-if="itemSon.reply_head"
                        :src="itemSon.reply_head"
                        @error="
                          (event) => {
                            let img = event.srcElement
                            img.src = errorHeadImg
                            img.onerror = null
                          }
                        "
                      />
                      <img v-if="!itemSon.reply_head" :src="errorHeadImg" />
                    </head-pendant>
                  </div>
                  <div class="info">
                    <div class="namebox">
                      <div class="name flex-ac">
                        <div class="over-ell-1">
                          {{ itemSon.reply_name }}
                        </div>
                        <img
                          v-if="itemSon.authorlevel && itemSon.authorlevel != 0"
                          :src="$getVipLevel(itemSon.authorlevel)"
                        />
                        <div v-if="itemSon.reply_to_name" class="sj"></div>
                        <div class="over-ell-1">{{ itemSon.reply_to_name }}</div>
                      </div>
                      <div class="time" v-if="itemSon.isauthor">作者</div>
                    </div>
                    <div class="comment_content_info">
                      <div class="comment_txt">
                        {{ itemSon.reply }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="comment_content_info"
                  @click.stop="
                    commentFn({ item: item, index: index, itemSon: itemSon, indexSon: indexSon })
                  "
                >
                  <div class="comment_txt name time" style="padding-left: 0.2rem;">
                    {{ itemSon.reply_time }}
                  </div>
                  <div class="comment_txt name time reply_btn">
                    回复
                  </div>
                </div>
              </div>
              <!--            <div class="love" @click.stop="likeFn({item: item, index: index, itemSon: itemSon, indexSon: indexSon})">-->
              <!--              <img :src="itemSon.ispraise == 0 ? '/static/images/community/notlike.png' : '/static/images/community/like.png'">-->
              <!--              <p>{{itemSon.praisenum}}</p>-->
              <!--            </div>-->
            </div>
            <div
              class="more"
              v-if="
                item.comment_reply.length > 0 &&
                  item.comment_reply.length % 5 == 0 &&
                  item.ismorereply
              "
              @click.stop="more({ item: item, index: index })"
            >
              展开更多回复
            </div>
          </div>
        </div>
        <div
          v-else
          style="
        font-size:0.13rem;
        font-weight:400;
        color:rgba(110,110,110,1);
        line-height:0.18rem;
        margin-top: 1.21rem;
        text-align: center;
        "
        >
          暂时还没有人留言，快来抢吧～
        </div>
      </div>
    </Scroller>
    <div class="leaveMsg footerIOS">
      <div class="inp">
        <img src="../../assets/images/edit.png" />
        <!--<input placeholder="说点什么…"/>-->
        <textarea
          class="van-cell"
          id="comment"
          @focus="enter"
          @blur="leave"
          :placeholder="placeholder"
          v-model="value"
        ></textarea>
        <!--<van-field @focus="submit = true" @blur="submit = false" v-model="value" placeholder="说点什么…" />-->
      </div>
      <div class="btn">
        <!--<div class="msg" v-if="value.length <= 0">-->
        <!--<img src="../../assets/images/ly.png"/>{{commentinfo.commentinfo.comment_nums}}&nbsp;-->
        <!--</div>-->
        <!--v-if="value.length > 0"-->
        <div class="msg" v-if="!likeShow" @click="submitComment">
          提交
        </div>
        <div class="zan" v-if="likeShow" @click.stop="likeFn">
          <img
            :src="
              commentinfo.ispraise == 0
                ? '/static/images/community/home-Select-icon-default1@2x.png'
                : '/static/images/community/like.png'
            "
          />
          <span class="txt">
            {{ commentinfo.praisenum > 999 ? '999+' : commentinfo.praisenum }}
          </span>
        </div>
        <div class="zan" v-if="likeShow" @click.stop="collectionFn">
          <img
            :src="
              commentinfo.iscollection == 0
                ? '/static/images/community/collection-icon-default1@2x.png'
                : '/static/images/community/collection1.png'
            "
          />
          <span class="txt">
            {{ commentinfo.collectionnum > 999 ? '999+' : commentinfo.collectionnum }}
          </span>
        </div>
        <div class="zan" v-if="likeShow">
          <img src="/static/images/community/comments-icon-default1@2x.png" />
          <span class="txt">
            {{ commentinfo.commentnum > 999 ? '999+' : commentinfo.commentnum }}
          </span>
        </div>
      </div>
      <van-action-sheet v-model="commentShow" :actions="commentActions" @select="commentOnselect" />
    </div>
    <van-overlay :show="show" :custom-style="{ background: 'rgba(0, 0, 0, .4)' }" lock-scroll />
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
      <img
        src="/static/images/community/integralreward.png"
        v-if="commentinfo && commentinfo.ismyself != 1 && commentinfo.isreward == 1"
        @click="integralreward"
      />
      <img src="/static/images/community/release1.png" @click="goRelease" />
      <img src="/static/images/community/community.png" @click="communityClick" />
      <img src="/static/images/community/home.png" @click="homeClick" />
    </div>
    <van-action-sheet v-model="productShow" title="关联商品">
      <div style="max-height: 3.92rem">
        <van-cell-group inset>
          <van-cell
            v-for="(item, index) of commentinfo.productlist"
            :key="index"
            @click="goProductDetail(item)"
          >
            <template #default>
              <div class="productItem flex">
                <img class="flex-s" v-lazy="item.img_path" />
                <div class="name flex-1">
                  <p class="f13 over-ell-2">{{ item.name }}</p>
                  <p class="f12 price color-FC0324">
                    <label class="xian">
                      <sub>¥</sub>
                      <b>
                        {{
                          String(item.sales_price).slice(0, String(item.sales_price).indexOf('.'))
                        }}
                      </b>
                      <sup>
                        {{
                          String(item.sales_price).slice(
                            String(item.sales_price).indexOf('.'),
                            String(item.sales_price).length
                          )
                        }}
                      </sup>
                    </label>
                    <span class="f10 color-9">¥{{ item.cost_price }}</span>
                  </p>
                  <span class="f10 color-9">
                    查看商品
                    <van-icon name="arrow" size="0.12rem!important" color="#999999" />
                  </span>
                </div>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-action-sheet>
    <van-dialog
      v-model="integralrewardshow"
      z-index="2001"
      :title="'请输入打赏金额'"
      :message="'让我们为每一位创作者打call'"
      :show-confirm-button="false"
      :before-close="(action, done) => done(false)"
      class="reward_button_alert percen_button_alert"
    >
      <div class="van-dialog__message van-dialog__message--has-title" style="white-space: initial">
        让我们为每一位创作者打call
        <input
          class="integralrewardnum"
          type="number"
          v-model="integralrewardnum"
          placeholder="最高可打赏300个金币"
        />
      </div>
      <div class="van-hairline--top van-dialog__footer">
        <van-button
          size="large"
          class="van-dialog__confirm"
          @click="confirmReward"
          :color="integralrewardnum == '' || integralrewardnum == 0 ? '#FC032488' : ''"
        >
          打赏
        </van-button>
      </div>
    </van-dialog>
    <van-icon
      v-if="integralrewardshow"
      class="dialog_close"
      name="close"
      size="0.26rem"
      color="#ffffff"
      @click="
        integralrewardnum = ''
        integralrewardshow = false
      "
    />
    <van-overlay :show="showshare" v-if="showshare" z-index="99">
      <div class="sharecontainer sharefriend" v-if="showshare === true">
        <img src="/static/wx/img/sharebg2.png" />
        <van-button round plain type="danger" class="know" @click="showshare = false">
          我知道了
        </van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import zymedia from '../../assets/js/zy.media'
import { isWeixin, fenxiang, appid, Base64, unencryption } from '../../assets/common/js/config'
import { Rate, ImagePreview } from 'vant'
import Scroller from '../common/Scroller'
import star from '../common/star'
import headPendant from '../common/headPendant'
import '../../../static/wx/css/mobilePop.css'
import Vue from 'vue'
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(ImagePreview)
export default {
  name: 'communityDetail',
  components: {
    [Rate.name]: Rate,
    Scroller,
    star,
    headPendant
  },
  data() {
    var that = this
    return {
      // submit: false,
      activeIndex: 0,
      bannerSwiper: null,
      commentinfo: {},
      commentlist: [],
      commentObj: null,
      placeholder: '说点什么…',
      likeShow: true,
      value: '',
      msg: '',
      bannerList: [],
      radio: null,
      swiperOption: {
        autoplay: true,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function() {
            // console.log(this.activeIndex) // 切换结束时，告诉我现在是第几个slide
            that.activeIndex = this.activeIndex
          }
        }
      },
      imgShow: false,
      icon: 'play',
      refresh: false,
      loading: false,
      finished: false,
      disabled: true,
      nowPage: 0,
      noDataText: '',
      replyloading: true,
      commentShow: false,
      commentActions: [{ name: '回复' }, { name: '举报' }],
      show: false,
      id: '',
      productShow: false,
      integralrewardshow: false,
      integralrewardnum: '',
      isunfold: false,
      isnewpersontask: 0,
      newpersonjump: '',
      showshare: false
    }
  },
  mounted: function() {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.pagesize = 5
    let that = this
    that.getData()
    // that.nowPage = 1
    // that.getLeaveData()
    that.$nextTick(function() {
      that.bannerSwiper = new Swiper('#pro_pic', {
        autoplay: false,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function() {
            that.activeIndex = this.activeIndex
          }
        }
      })
      window.addEventListener('scroll', that.scrollWatch)
      var videoBar = $('#Glide .swiper-slide')
      var video = videoBar.find('video')
      let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (!isiOS) {
        setTimeout(() => {
          let videoContexts = document.querySelectorAll('.zy_media video')
          videoContexts.forEach((videoContext) => {
            let imgElement = document.createElement('img')
            imgElement.style.display = 'block'
            imgElement.style.width = '100%'
            imgElement.src = that.productDateils.video_img_url
            videoContext.parentNode.style.display = 'block'
            videoContext.parentNode.append(imgElement)
            videoContext.addEventListener('play', () => {
              imgElement.style.display = 'none'
              videoContext.style.display = 'block'
              videoContext.parentNode.style.display = 'block'
              that.bannerSwiper.autoplay.stop()
            })
            videoContext.addEventListener('pause', () => {
              imgElement.style.display = 'block'
              videoContext.style.display = 'none'
              // videoContext.parentNode.style.display = "none";
              that.bannerSwiper.autoplay.start()
            })
          })
        }, 500)
      } else {
        video.on('play', function() {
          that.bannerSwiper.autoplay.stop()
        })
        video.on('pause', function() {
          that.bannerSwiper.autoplay.start()
        })
      }
    })
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.id = vm.$route.query.id ? vm.$route.query.id : ''
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.placeholder = '说点什么…'
        vm.value = ''
        vm.activeIndex = 0
        vm.commentObj = null
        vm.commentinfo = {}
        vm.bannerList = []
        vm.getData()
        vm.commentlist = []
        vm.nowPage = 0
        vm.$clickburiedPoint({
          data: {
            postid: vm.$route.query.id
          },
          url: 'community/userbehavior/save'
        })
        if (vm.$route.query.shareOpenid) {
          vm.$clickburiedPoint({
            url: 'community/userbehavior/save'
          })
        }
      })
    } else {
      next((vm) => {
        vm.$clickburiedPoint({
          data: {
            postid: vm.$route.query.id
          },
          url: 'community/userbehavior/save'
        })
        if (vm.$route.query.shareOpenid) {
          vm.$clickburiedPoint({
            url: 'community/userbehavior/save'
          })
        }
        if (from.path != '/communityreport' && vm.$route.query.id != vm.id) {
          vm.id = vm.$route.query.id ? vm.$route.query.id : ''
          setTimeout(function() {
            window.scrollTo(0, 0)
          }, 0) // 同步转异步操作
          vm.refresh = false
          vm.loading = false
          vm.finished = false
          vm.placeholder = '说点什么…'
          vm.value = ''
          vm.activeIndex = 0
          vm.commentObj = null
          vm.commentinfo = {}
          vm.bannerList = []
          vm.getData()
          vm.commentlist = []
          vm.nowPage = 0
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path != '/communityreport' && this.$route.query.id != this.id) this.loading = true
    next()
  },
  watch: {
    integralrewardnum(n, o) {
      if (n > 300) {
        this.integralrewardnum = o
      }
    }
  },
  methods: {
    getData: function() {
      var url = this.$ajax.getPostsDetail_URL + '?itemid=' + this.id
      url += '&fromway=' + (this.$route.query.shareOpenid ? 2 : 1)
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          if (that.$store.state.communityDetail) {
            var list = JSON.parse(that.$store.state.communityDetail)
            list.map(function(item) {
              if (item.id == that.$route.query.id) {
                if (!item.itemid) {
                  res.data.data.productlist = []
                } else {
                  let goods = res.data.data.productlist
                  goods.map((goodsItem) => {
                    if (item.itemid.indexOf(goodsItem.itemid) >= 0) {
                      goods.splice(item.itemid.indexOf(goodsItem.itemid), 1, {})
                    }
                  })
                  let goods_new = []
                  goods.map((goodsItem) => {
                    if (goodsItem.itemid) {
                      goods_new.push(goodsItem)
                    }
                  })
                  res.data.data.productlist = goods_new
                }
                return
              }
            })
          }
          that.commentinfo = res.data.data
          that.commentinfo.content = that.commentinfo.content.replace(/\n/g, '<br/>')
          that.bannerList = that.commentinfo.images.map((item) => {
            // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start
            item =
              item +
              (that.$cos.isCosSwitch == 1
                ? that.$cos.pathSymbol(item) + that.$cos.imageLinkParamsStr
                : '?x-oss-process=image/format,jpg')
            // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End
            return item
          })
          if (isWeixin()) {
            if (that.commentinfo.sharedata && that.commentinfo.sharedata.title) {
              var base = new Base64()
              fenxiang({
                title: encodeURIComponent(that.commentinfo.sharedata.title),
                desc: encodeURIComponent(that.commentinfo.sharedata.desc),
                imgx: that.commentinfo.sharedata.img,
                type: 'communitydetail',
                dataStr:
                  'type=communitydetail&params=' +
                  base.encode(
                    JSON.stringify({
                      id: that.$route.query.id,
                      subjectid: that.commentinfo.subjectid,
                      shareOpenid: appid,
                      productName: encodeURI(that.title)
                    })
                  ),
                path: 'communitydetail',
                callback: function() {
                  that.$clickburiedPoint({
                    data: {
                      postid: that.$route.query.id,
                      isshare: 1
                    },
                    url: 'community/userbehavior/save'
                  })
                }
              })
              if (sessionStorage.getItem('communityevaluation_msg')) {
                that.$dialog
                  .alert({
                    message: unencryption(sessionStorage.getItem('communityevaluation_msg')),
                    className: 'percen_button_alert integral_button_alert',
                    messageAlign: 'center',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去分享',
                    closeOnPopstate: false
                  })
                  .then(() => {
                    that.showshare = true
                  })
                  .catch(() => {})
                sessionStorage.removeItem('communityevaluation_msg')
              }
            } else {
              fenxiang({ path: 'communitydetail' })
            }
          }
          // that.commentinfo.commentinfo.itemscore = parseInt(res.data.commentinfo.itemscore)
        }
      })
      that.$newuserFn((data) => {
        if (data.code == 200) {
          that.isnewpersontask = data.isnewpersontask
          that.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    getLeaveData: function() {
      var url =
        this.$ajax.getCommentList_CommunityPosts_URL +
        '?itemid=' +
        this.$route.query.id +
        '&pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          res.data.data.commentlist.map((item) => {
            item.reply_nowpage = 2
            if (item.comment_reply.length >= this.pagesize) {
              item.ismorereply = true
            } else {
              item.ismorereply = false
            }
          })
          if (that.nowPage === 1) {
            that.commentlist = res.data.data.commentlist
            that.refresh = false
          } else {
            that.commentlist = that.commentlist.concat(res.data.data.commentlist)
          }
          that.loading = false
          if (res.data.data.commentlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    more: function(obj) {
      if (!this.replyloading) return
      this.replyloading = false
      var url =
        this.$ajax.getReplyList_URL +
        '?pageno=' +
        parseInt(obj.item.reply_nowpage) +
        '&pagesize=' +
        this.pagesize +
        '&commentid=' +
        obj.item.commentid
      obj.item.reply_nowpage = parseInt(obj.item.reply_nowpage) + 1
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.replyloading = true
          if (res.data.data.comment_reply.length > 0) {
            obj.item.comment_reply = obj.item.comment_reply.concat(res.data.data.comment_reply)
            obj.item.ismorereply = true
          } else {
            obj.item.ismorereply = false
          }
        }
      })
    },
    loadvideo: function() {
      setTimeout(function() {
        zymedia('#banner_video', {
          aspectRation: '375' / '667',
          preload: 'auto',
          alwaysShowControls: true,
          hideVideoControlsOnLoad: true
        })
      })
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getLeaveData()
      // }, 400)
    },
    leave: function() {
      setTimeout(() => {
        this.likeShow = true
        this.show = false
        if (this.value == '') {
          this.commentObj = null
          this.placeholder = '说点什么…'
        }
      }, 50)
    },
    enter: function() {
      this.likeShow = false
      this.show = true
    },
    commentOnselect: function(item) {
      console.log(item)
      this.commentShow = false
      this.$nextTick(() => {
        if (item.name == '回复') {
          this.commentFn(this.commentObj)
        } else {
          this.report(this.commentObj)
        }
      })
    },
    rewarddetails: function() {
      if (this.commentinfo.rewardvalue > 0) {
        this.$router.push('/rewarddetails?id=' + this.$route.query.id)
      }
    },
    openSelect: function(obj) {
      this.commentObj = obj
      this.commentShow = true
    },
    commentFn: function(obj) {
      this.commentObj = obj
      document.getElementById('comment').focus()
      setTimeout(() => {
        if (obj.item.isdeleted != 1) {
          this.placeholder = obj.itemSon
            ? '回复' + obj.itemSon.reply_name
            : obj.item
            ? '回复' + obj.item.comment_name
            : '说点什么…'
          console.log(document.getElementById('comment').focus())
        }
      }, 50)
    },
    submitComment() {
      if (this.value == '') {
        return
      }
      this.$ckeckgraphic({
        content: this.value,
        callback: () => {
          var url = this.$ajax.comment_URL
          var data = {
            itemid: this.$route.query.id,
            comment: this.value
          }
          if (this.commentObj) {
            if (this.commentObj.itemSon) {
              url = this.$ajax.reply_URL
              data = {
                replyid: this.commentObj.itemSon.replyid,
                replycontent: this.value
              }
            } else if (this.commentObj.item) {
              url = this.$ajax.commentReply_URL
              data = {
                commentid: this.commentObj.item.commentid,
                replycontent: this.value
              }
            }
          }
          var that = this
          if (this.value.replace(/ /g, '') != '') {
            this.$customRequestAjax.post(url, data).then((res) => {
              if (res.data.code == 200) {
                that.nowPage = 1
                that.getLeaveData()
                this.value = ''
                this.leave()
              }
            })
          } else {
            this.$toast('内容不能为空')
          }
        }
      })
    },
    goHome: function() {
      this.$store.commit('COMMUNITY_CENTER_TAB', 0)
      if (this.commentinfo.ismyself == 1) {
        this.$router.push({
          path: '/communitycenter'
        })
      } else {
        this.$router.push({
          path: '/communitycenter',
          query: {
            authorid: this.commentinfo.authorid
          }
        })
      }
    },
    followFn: function() {
      var url = this.$ajax.community_follow_URL,
        data = {
          authorid: this.commentinfo.authorid,
          isfollow: this.commentinfo.isfollow ? 0 : 1
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          this.commentinfo.isfollow = this.commentinfo.isfollow == 1 ? 0 : 1
        }
      })
    },
    report(obj) {
      if (!obj.item) {
        this.$router.push({
          path: '/communityreport',
          query: {
            id: this.$route.query.id,
            reporttype: 0
          }
        })
      } else if (obj && obj.itemSon) {
        this.$router.push({
          path: '/communityreport',
          query: {
            id: obj.itemSon.replyerid,
            reporttype: 2
          }
        })
      } else {
        this.$router.push({
          path: '/communityreport',
          query: {
            id: obj.item.commentid,
            reporttype: 1
          }
        })
      }
    },
    preview(index) {
      var that = this
      ImagePreview({
        images: that.bannerList,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    goSubjectid: function() {
      this.$router.push({
        path: '/communityfollow',
        query: {
          subjectid: this.commentinfo.subjectid,
          subject: encodeURIComponent(this.commentinfo.subject)
        }
      })
    },
    goProductDetail(item) {
      if (item.is_sale == 0) {
        this.$toast('该商品已下架')
      } else {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: {
            itemid: item.itemid,
            scenepoint: 'COMMUNITYPOSTDETAIL',
            scenedesc: this.$route.query.id
          }
        })
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: item.itemid
          }
        })
      }
    },
    likeFn: function(obj) {
      var url = this.$ajax.communityPosts_likes_URL,
        data = {
          type: 1,
          postsid: this.$route.query.id
        }
      // if (obj.itemSon) {
      //   data.ispraise = obj.itemSon.ispraise == 0 ? 1 : 0
      //   data.commentid = obj.itemSon.replyid
      // } else
      if (obj.item) {
        data.ispraise = obj.item.ispraise == 0 ? 1 : 0
        data.commentid = obj.item.commentid
      } else {
        data.type = 0
        data.ispraise = this.commentinfo.ispraise == 0 ? 1 : 0
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          if (obj.itemSon) {
            f(this.commentlist[obj.index].comment_reply[obj.indexSon])
          } else if (obj.item) {
            f(this.commentlist[obj.index])
          } else {
            f(this.commentinfo)
          }
        }
      })
      function f(item) {
        if (item.ispraise == 0) {
          return (item.ispraise = 1), item.praisenum++
        } else {
          return (item.ispraise = 0), item.praisenum--
        }
      }
    },
    collectionFn: function() {
      var url = this.$ajax.communityPosts_collection_URL,
        data = {
          itemid: this.$route.query.id,
          iscollection: this.commentinfo.iscollection == 0 ? 1 : 0
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          if (this.commentinfo.iscollection == 0) {
            this.commentinfo.iscollection = 1
            this.commentinfo.collectionnum++
          } else {
            this.commentinfo.iscollection = 0
            this.commentinfo.collectionnum--
          }
        }
      })
    },
    closeFn: function(item) {
      var list = [],
        temp = 0
      if (this.$store.state.communityDetail) {
        list = JSON.parse(this.$store.state.communityDetail)
      }

      for (var i in list) {
        if (list[i].id == this.$route.query.id) {
          list[i].itemid.push(item.itemid)
          temp = 1
          break
        }
      }
      if (temp == 0) {
        list.push({
          id: this.$route.query.id,
          isshow: 0,
          itemid: [item.itemid]
        })
      }
      this.$store.commit('COMMUNITY_DETAIL', JSON.stringify(list))
      let index = -1
      this.commentinfo.productlist.map((goodsItem, goodsIndex) => {
        if (goodsItem.itemid == item.itemid) {
          index = goodsIndex
        }
      })
      if (index > -1) this.commentinfo.productlist.splice(index, 1)
    },
    integralreward: function() {
      this.integralrewardshow = true
    },
    goRelease: function() {
      var that = this
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({ id: this.$route.query.id }))
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'communitydetail'
            }
          })
        } else {
          f()
        }
      } else {
        f()
      }
      function f() {
        that.$clickburiedPoint({
          data: {
            buttonCode: 'posted'
          },
          url: 'community/userbehavior/save'
        })
        that.$router.push({
          path: '/communityevaluation'
        })
      }
    },
    homeClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'tomall'
        },
        url: 'community/userbehavior/save'
      })
      this.$router.push('/')
    },
    communityClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'tocommunity'
        },
        url: 'community/userbehavior/save'
      })
      this.$store.commit('COMMUNITY_TAB', 1)
      this.$router.push('/community')
    },
    confirmReward: function() {
      if (this.integralrewardnum != '' && this.integralrewardnum > 0) {
        if (this.integralrewardnum > 300) {
          this.$toast('最高可打赏300个金币')
          return
        }
        var url = this.$ajax.sendPostsIntegral_URL,
          data = {
            itemid: this.$route.query.id,
            goldnum: this.integralrewardnum
          }
        this.$customRequestAjax.post(url, data).then((res) => {
          if (res.data.code == 200) {
            this.integralrewardnum = ''
            this.integralrewardshow = false
            this.$toast('打赏成功')
          }
        })
      }
    }
    // areablur () {
    //   setTimeout(() => {
    //     this.submit = false
    //   })
    // }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/productList';
.container.communityDetail {
  /*background: #fff;*/
  padding-bottom: 0.6rem;
  position: relative;
  .maininfo {
    position: relative;
    .report {
      position: absolute;
      right: 0.2rem;
      top: 0.2rem;
      z-index: 1;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
    .swiper-container {
      .swiper_height {
        .downVideo {
          display: block;
          color: #ffffff;
          font-size: 0.1rem;
          line-height: 0.13rem;
          position: absolute;
          right: 0.1rem;
          top: 0.1rem;
          padding: 0.02rem 0.1rem;
          border-radius: 0.2rem;
          border: 0.01rem solid #ffffff;
        }
        #banner_video {
          /*object-fit:cover;*/
        }
      }
      .swiper-wrapper {
        margin: 0;
        padding: 0;
        /*height: 100%;*/
        .swiper-slide {
          padding: 0;
          margin: 0;
          position: relative;
          img {
            width: 100%;
            display: block;
            border: 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
          }
        }
      }
      #proSwiperPagination {
        font-size: 0.12rem;
        width: 0.34rem;
        color: #fff;
        position: absolute;
        right: 0.11rem;
        left: auto;
        /*<!--margin-left: -.17rem;-->*/
        bottom: 0.15rem;
        .pro_page {
          /*position: relative;*/
          background: url(../../assets/images/pagebg.png) no-repeat center;
          background-size: 100% 100%;
          padding: 0 0.0385rem 0.01rem;
          white-space: nowrap;
          .swiper-pagination-current {
            width: 0.12rem;
            border-radius: 0.12rem;
            /*position: absolute;*/
            /*top: 0;*/
            /*left: 0;*/
            /*background: #757575;*/
          }
          .swiper-pagination-split {
            margin-left: 0.02rem;
            margin-right: 0.02rem;
            /*position: absolute;*/
            /*top: 0;*/
            left: 0.08rem;
            height: 0.12rem;
            line-height: 0.12rem;
            margin-top: 0.01rem;
            /*background: #757575;*/
            text-align: center;
            font-size: 0.12rem;
            transform: scale(0.8);
          }
          .swiper-pagination-total {
            width: 0.12rem;
            border-radius: 0.12rem;
            /*position: absolute;*/
            /*top: 0;*/
            left: 0.14rem;
            /*background: #757575;*/
          }
        }
      }
      .playTab {
        /*font-size: 0;*/
        text-align: center;
        position: absolute;
        bottom: 0.15rem;
        z-index: 1;
        left: 0;
        right: 0;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -o-justify-content: center;
        -ms-justify-content: center;
        span {
          width: 0.47rem;
          height: 0.22rem;
          text-align: center;
          background: rgba(249, 249, 249, 1);
          border-radius: 0.11rem;
          border: 0.01rem solid rgba(224, 225, 224, 1);
          font-size: 0.11rem;
          font-weight: 400;
          color: rgba(53, 53, 53, 1);
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -o-flex;
          display: -ms-flex;
          align-items: center;
          -webkit-align-items: center;
          -moz-align-items: center;
          -o-align-items: center;
          -ms-align-items: center;
          justify-content: center;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -o-justify-content: center;
          -ms-justify-content: center;
          b {
            font-weight: 400;
            transform: scale(0.98);
            -webkit-transform: scale(0.98);
            -moz-transform: scale(0.98);
            -ms-transform: scale(0.98);
            -o-transform: scale(0.98);
          }
          &:first-of-type {
            margin-right: 0.045rem;
          }
          &:last-of-type {
            margin-left: 0.045rem;
          }
        }
      }
    }
  }
  .commentProduct {
    padding: 0.1rem 0.11rem;
    background: #ffffff;
    .left {
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -o-align-items: center;
      -ms-align-items: center;
      height: 0.4rem;
      img {
        width: 0.3rem;
        height: 0.3rem;
        vertical-align: bottom;
      }
      p {
        font-size: 0.13rem;
        font-weight: 400;
        color: rgba(41, 41, 41, 1);
        /*line-height:0.3rem;*/
        margin-left: 0.1rem;
        margin-right: 0.06rem;
      }
      i {
        max-width: 0.72rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 0.11rem;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        /*line-height:0.3rem;*/
        font-style: normal;
      }
    }
    .right {
      height: 0.4rem;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -o-align-items: center;
      -ms-align-items: center;
      img {
        width: 0.36rem;
        height: 0.36rem;
      }
      p {
        font-size: 0.13rem;
        font-weight: 400;
        color: rgba(74, 144, 226, 1);
        text-decoration: underline;
      }
    }

    &.pro_comment_item {
      .comment_head_info {
        display: flex;
        align-items: center;
        /*overflow: hidden;*/
        .sj {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 9;
          font-size: 0.12rem;
          .van-icon-star {
            font-size: 0.13rem;
          }
        }
        .report {
          position: absolute;
          top: 0.16rem;
          right: 0;
          font-size: 0.13rem;
          color: #191818;
          margin-top: 0.1rem;
          img {
            width: 0.1rem;
            height: 0.12rem;
            display: inline-block;
            /*vertical-align: middle;*/
            margin-right: 0.02rem;
          }
        }
        .img {
          width: 0.37rem;
          float: left;
          img {
            width: 0.37rem;
            height: 0.37rem;
            border-radius: 0.37rem;
            object-fit: cover;
          }
        }
        .info {
          float: left;
          position: relative;
          .name {
            /*font-size: .14rem;*/
            line-height: 0.2rem;
            padding-left: 0.1rem;
            width: 2rem;
            img {
              /*width: 0.35rem;*/
              height: 0.16rem;
              margin-left: 0.02rem;
            }
          }

          .time {
            font-size: 0.12rem;
            transform: scale(0.85);
            color: #afb0af;
          }
        }
      }
      .comment_head_btn {
        display: flex;
        align-items: center;
        button {
          color: #fc0324;
          border: 0.005rem solid #fc0324;
          line-height: 0.12rem;
          height: 0.24rem;
          min-width: 0.56rem;
          border-radius: 0.12rem;
          outline: none;
          background: transparent;
          padding: 0.05rem 0.08rem;
          &.gray {
            border-color: #afb0af;
            color: #afb0af;
          }
        }
        &.report {
          img {
            width: 0.2rem;
            height: 0.2rem;
          }
        }
      }
    }
    &.community_userinfo {
      background: transparent;
      color: #ffffff;
      .comment_head_info {
        .info {
          .name {
            width: auto;
            max-width: 2rem;
          }
        }
      }
      .comment_head_btn {
        margin-left: 0.12rem;
        button {
          background: #fc0324;
          color: #ffffff;
          &.gray {
            border-color: #fc0324;
            color: #fc0324;
            background: transparent;
          }
        }
      }
    }
  }
  .community_content {
    position: absolute;
    bottom: 0.44rem;
    width: 100%;
    .maincontent {
      margin: 0;
      padding: 0.02rem 0.15rem 0;
      background: transparent;
      .comment_txt,
      .topic {
        color: #ffffff;
        &.content {
          max-height: 1.4rem;
          &.overflow {
            overflow-y: auto;
          }
        }
      }
      .topic {
        background: transparent;
        padding-left: 0;
      }
    }
  }
  .maincontent {
    padding: 0.15rem 0.11rem;
    margin: 0.1rem 0.11rem;
    background: #ffffff;
    border-radius: 0.04rem;
    .comment_txt {
      color: #222222;
    }
    .topic {
      display: flex;
      align-items: center;
      padding-left: 0.26rem;
      background: url(/static/images/community/community-topic-selected.png) no-repeat left center;
      background-size: 0.18rem 0.18rem;
      color: #fc0324;
      margin-top: 0.1rem;
      position: relative;
    }
    .product {
      background: #fff;
      border-radius: 0 0 0.04rem 0.04rem;
      /*padding-right: 0.52rem;*/
      position: relative;
      &.marginTop {
        margin-top: 0.14rem;
      }
      > p {
        color: #6c6c6c;
        font-size: 0.13rem;
        margin: 0 0 0.11rem;
      }
      .moreProduct {
        position: absolute;
        right: -0.1rem;
        top: -0.01rem;
        bottom: -0.01rem;
        text-align: center;
        background: #ffffff;
        padding: 0.16rem 0.08rem;
        box-shadow: -0.2rem 0 0.1rem -0.16rem rgba(159, 159, 159, 0.5);
      }
    }
  }
  .comment_list {
    padding: 0.15rem 0.11rem;
    margin: 0.1rem 0.11rem;
    padding-bottom: 0.6rem;
    background: #ffffff;
    border-radius: 0.04rem;
    .comment_tit {
      /*height: .41rem;*/
      /*line-height: .41rem;*/
      /*border-bottom: solid 1px rgba(239,239,239,1);*/
      /*margin: 0 .11rem;*/
      font-size: 0.13rem;
      color: #333333;
      display: flex;
      align-items: center;
      font-weight: bold;
      img {
        width: 0.25rem;
        height: 0.25rem;
        display: block;
        margin-right: 0.07rem;
      }
    }
    .list {
      .pro_comment_item {
        /*padding: 0 .11rem;*/
        margin-top: 0.2rem;
        .pro_comment_item_box {
          display: flex;
          justify-content: space-between;
          &.comment_reply_item {
            margin-left: 0.36rem;
            position: relative;
            .comment_head_info {
              .img {
                width: 0.2rem;
                img {
                  width: 0.2rem;
                  height: 0.2rem;
                }
              }
            }
          }
          .comment_head_info {
            position: relative;
            /*overflow: hidden;*/
            display: flex;
            .img {
              width: 0.3rem;
              float: left;
              img {
                width: 0.3rem;
                height: 0.3rem;
                border-radius: 50%;
              }
            }
            .info {
              float: left;
              position: relative;
              .namebox {
                display: flex;
                align-items: center;
                .name {
                  font-size: 0.14rem;
                  line-height: 0.2rem;
                  padding-left: 0.1rem;
                  color: #999999;
                  max-width: 2.4rem;
                  img {
                    /*width: 0.3rem;*/
                    height: 0.14rem;
                    margin-left: 0.02rem;
                  }
                  .sj {
                    width: 0;
                    height: 0;
                    border: 0.03rem solid transparent;
                    border-left-color: #999999;
                    margin-left: 0.04rem;
                  }
                }
                .time {
                  font-size: 0.08rem;
                  border: 0.005rem solid #fc0324;
                  border-radius: 0.02rem;
                  transform: scale(0.85);
                  color: #fc0324;
                  margin-left: 0.05rem;
                }
              }
            }
          }
          .comment_content_info {
            padding-left: 0.1rem;
            display: flex;
            .comment_txt {
              font-size: 0.14rem;
              line-height: 0.2rem;
              color: #333333;
              word-break: break-word;
              &.delete {
                text-decoration: line-through;
              }
              &.time {
                font-size: 0.1rem;
                margin-top: 0.08rem;
                color: #999999;
              }
            }
            .reply_btn {
              margin-left: 0.05rem;
            }
          }
          .love {
            img {
              margin: 0 auto;
              width: 0.16rem;
              height: 0.16rem;
            }
            p {
              color: #999999;
              font-size: 0.1rem;
              text-align: center;
            }
          }
        }
        .more {
          margin-left: 0.65rem;
          margin-top: 0.1rem;
          font-size: 0.13rem;
          color: #338bf6;
        }
      }
    }
  }
  .leaveMsg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    /*height: .43rem;*/
    border-top: solid 1px rgba(0, 0, 0, 0.25);
    z-index: 9;
    background: #fff;
    padding: 0 0.11rem;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -o-align-items: center;
    -ms-align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -o-justify-content: space-between;
    -ms-justify-content: space-between;
    .inp {
      /*width: 2.11rem;*/
      background: #f5f5f5;
      height: 0.29rem;
      margin: 0.1rem 0;
      display: flex;
      align-items: center;
      font-size: 0.13rem;
      border-radius: 0.15rem;
      color: #999999;
      flex: 1;
      input {
        border: 0;
        background: transparent;
        color: #292929;
      }
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-left: 0.1rem;
        margin-right: 0.05rem;
        pointer-events: none;
        -webkit-user-select: none;
        -webkit-touch-callout: none;
        word-break: break-word;
      }
    }
    .btn {
      margin: 0.1rem 0;
      display: flex;
      align-items: center;
    }
    .msg {
      float: left;
      display: flex;
      align-items: center;
      margin-left: 0.1rem;
      font-size: 0.14rem;
      padding: 0.1rem;
      color: #4a90e2;
      white-space: nowrap;
      img {
        width: 0.22rem;
        height: 0.19rem;
        margin-right: 0.09rem;
      }
    }
    .zan {
      float: right;
      display: flex;
      align-items: center;
      margin-left: 0.11rem;
      font-size: 0.13rem;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.05rem;
      }
      .txt {
        color: #6d6d6d;
      }
    }
  }
  .van-popup {
    .van-action-sheet__header {
      position: static;
      .van-action-sheet__close {
        background: url('../../assets/images/closex.png') no-repeat center;
        background-size: 0.2rem 0.2rem;
        padding-right: 0.21rem;
      }
    }
    .van-action-sheet__content {
      .van-hairline--top-bottom {
        /*position: static;*/
      }
      .van-cell {
        /*position: static;*/
      }
      .van-radio__icon--round .van-icon {
        border-radius: 1.25rem;
      }
    }
  }
  .report_btn {
    width: 3.53rem;
    height: 0.43rem;
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    border-radius: 0.25rem;
    text-align: center;
    font-size: 0.17rem;
    color: #fff;
    line-height: 0.43rem;
    margin: 0.1rem auto;
    margin-top: 0.2rem;
    /*position: fixed;*/
    /*left: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    span {
      font-size: 0.13rem;
    }
  }
  .homeBtn {
    position: fixed;
    right: 0.16rem;
    bottom: 0.75rem;
    img {
      width: 0.45rem;
      height: 0.45rem;
      margin-top: 0.1rem;
    }
  }
  .productItem {
    img {
      width: 0.8rem;
      height: 0.8rem;
    }
    .name {
      position: relative;
      margin-left: 0.07rem;
      > span {
        position: absolute;
        right: 0;
        bottom: 0.02rem;
        .van-icon {
          vertical-align: middle;
        }
      }
      p {
        color: #292929;
        &.price {
          position: absolute;
          bottom: 0;
          margin-top: 0.1rem;
          font-size: 0.14rem;
          overflow: hidden;
          .xian {
            color: #fc0324;
            font-size: 0;
            line-height: 0.2rem;
            b {
              font-size: 0.14rem;
              font-weight: 600;
            }
            sub {
              font-weight: normal;
              font-size: 0.12rem;
              vertical-align: baseline;
            }
            sup {
              font-size: 0.11rem;
              vertical-align: baseline;
              font-weight: normal;
            }
          }
          span {
            margin-left: 0.04rem;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.leaveMsg {
  .van-cell {
    line-height: 0.29rem;
    background-color: transparent;
    width: 82%;
    padding: 0;
    height: 0.29rem;
    border: 0;
    outline: none;
    overflow-y: auto;
    &::placeholder {
      line-height: 0.29rem;
    }
  }
}
.communityDetail {
  .van-dialog__header {
    padding-bottom: 0.15rem;
    border-bottom: 0.01rem solid #efefef;
    margin: 0 0.15rem 0.09rem;
  }
  .van-dialog__content {
    padding-top: 0.17rem;
    margin: 0 0.15rem 0.13rem;
    height: 2.12rem;
    overflow-y: auto;
    .integralrewardnum {
      background: #f5f5f5;
      height: 0.41rem;
      border-radius: 0.04rem;
      outline: none;
      border-width: 0;
      text-align: center;
      margin-top: 0.08rem;
      width: 100%;
    }
    .van-radio-group {
      .van-cell-group {
        /*position: static;*/
        .van-cell {
          /*position: static;*/
          padding: 0;
          margin-bottom: 0.2rem;
          &:last-of-type {
            margin-bottom: 0;
          }
          .van-radio {
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/communityDetail.vue